module.exports = __webpack_public_path__ + "img/cobranca.052ecef2.png";